import React from 'react'
import { User, Mail, Phone, Calendar, MessageSquare, Eye, Edit, UserCircle } from 'lucide-react'
import { Lead } from '../../types'

interface KanbanCardProps {
 lead: Lead
 onEdit: (lead: Lead) => void
}

export const KanbanCard: React.FC<KanbanCardProps> = ({ lead, onEdit }) => {
 const getSourceIcon = (source: Lead['source']) => {
 switch (source) {
 case 'website':
 return <Eye className="h-3 w-3" />
 case 'whatsapp':
 return <MessageSquare className="h-3 w-3" />
 case 'phone':
 return <Phone className="h-3 w-3" />
 default:
 return <User className="h-3 w-3" />
 }
 }

 const getSourceLabel = (source: Lead['source']) => {
 const labels: Record<string, string> = {
 website: 'Site',
 whatsapp: 'WhatsApp',
 phone: 'Telefone',
 'walk-in': 'Presencial',
 email: 'Email',
 referral: 'Indicação',
 'social-media': 'Rede Social',
 other: 'Outro',
 }
 return labels[source] || source
 }

 return (
<div className="bg-card border border-border rounded-lg p-4 hover:border-accent/40 hover:bg-surface/40 transition-all cursor-pointer group">
 <div className="flex items-start justify-between mb-3">
 <div className="flex items-center gap-2.5">
<div className="h-8 w-8 bg-muted rounded-md flex items-center justify-center flex-shrink-0">
<User className="h-4 w-4 text-muted-foreground" />
 </div>
 <h4 className="text-sm font-semibold text-foreground leading-tight">
 {lead.name}
 </h4>
 </div>
 <button
 onClick={(e) => {
 e.stopPropagation()
 onEdit(lead)
 }}
 className="opacity-0 group-hover:opacity-100 p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
 title="Editar"
 >
 <Edit className="h-3.5 w-3.5" />
 </button>
 </div>

 <div className="space-y-1.5 mb-3">
 {(lead.phones && lead.phones.length > 0 ? lead.phones[0] : lead.phone) && (
 <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
 <Phone className="h-3 w-3 flex-shrink-0" />
 <span>{lead.phones && lead.phones.length > 0 ? lead.phones[0].phone : lead.phone}</span>
 {lead.phones && lead.phones.length > 1 && (
 <span className="text-accent font-medium">+{lead.phones.length - 1}</span>
 )}
 {lead.phones && lead.phones.length > 0 && lead.phones[0].isWhatsApp && (
 <MessageSquare className="h-3 w-3 text-emerald-500" />
 )}
 </div>
 )}

 {(lead.emails && lead.emails.length > 0 ? lead.emails[0] : lead.email) && (
 <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
 <Mail className="h-3 w-3 flex-shrink-0" />
 <span className="truncate">
 {lead.emails && lead.emails.length > 0 ? lead.emails[0].email : lead.email}
 </span>
 {lead.emails && lead.emails.length > 1 && (
 <span className="text-accent font-medium">+{lead.emails.length - 1}</span>
 )}
 </div>
 )}
 </div>

 {lead.vehicleInterest && lead.vehicleInterest.length > 0 && (
 <div className="flex flex-wrap gap-1 mb-2">
 {lead.vehicleInterest.slice(0, 2).map((interest) => (
 <span
 key={interest.id}
className="text-xs bg-muted text-foreground px-2 py-0.5 rounded-full font-medium"
 >
 {interest.vehicle.name}
 </span>
 ))}
 {lead.vehicleInterest.length > 2 && (
 <span className="text-xs text-muted-foreground">
 +{lead.vehicleInterest.length - 2}
 </span>
 )}
 </div>
 )}

 {lead.notes && (
 <p className="text-xs text-muted-foreground mb-3 line-clamp-2">{lead.notes}</p>
 )}

 <div className="space-y-1.5 pt-3 border-t border-border/80">
 {lead.assignedUser && (
 <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
 <UserCircle className="h-3 w-3 flex-shrink-0" />
 <span className="truncate">{lead.assignedUser.name}</span>
 </div>
 )}

 <div className="flex items-center justify-between">
 <div className="flex items-center gap-1 text-xs text-muted-foreground">
 {getSourceIcon(lead.source)}
 <span>{getSourceLabel(lead.source)}</span>
 </div>
 <div className="flex items-center gap-1 text-xs text-muted-foreground">
 <Calendar className="h-3 w-3" />
 {new Date(lead.createdAt).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}
 </div>
 </div>
 </div>
 </div>
 )
}
